import Vue from 'vue'
import axios from 'axios'
import { Cookies } from 'quasar'
import urls from 'assets/js/urls'
import { Notification } from 'element-ui'
import { Loading, QSpinnerBall } from 'quasar'
// <i18n-ignore
Vue.mixin({
    beforeCreate() {
        const options = this.$options
        if (options.axios) {
            this.$axios = options.axios
        } else if (options.parent) {
            this.$axios = options.parent.$axios
        }
    },
})
export default async ({ router, store, ssrContext, app, route } /* { app, router, Vue ... } */) => {
    const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies // 否则我们在客户端
    const service = axios.create({
        // baseURL: process.env.DEV ? process.env.DEV_API : "/api", // api base_url
        baseURL: process.env.SERVER ? `http://localhost:${process.env.PORT}/api` : '/api', // api base_url
        // baseURL: process.env.SERVER ? `https://test.xixiamro.com/api` : '/api',
        timeout: 15000, // 请求超时时间
    })
    const err = error => {
        console.log(error)
        if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || error.message.includes('timeout')) {
            Notification.error({
                title: '错误',
                message: '请求超时，请稍后重试',
            })
        }
        if (error.response) {
            if (error.response.status === 401) {
                if (error.response.config.url.indexOf('login') != -1) {
                    Notification.error({
                        title: error.response.data.message,
                    })
                } else {
                    if (!process.env.SERVER) {
                        if (document.getElementsByClassName('el-notification').length === 0) {
                            Notification.error({
                                title: '登录失效或已过期',
                                message: '请重新登录',
                            })
                        }
                    }
                    // if(['/purchaseDetail'].includes(window.location.pathname)){
                    //     store.dispatch('loginOut', window.location.pathname + window.location.search)
                    // } else {
                    //     store.dispatch('loginOut')
                    // }
                    store.dispatch('loginOut', window.location.pathname + window.location.search)
                }
            } else if (error.response.status === 404) {
                // router.push("/404");
            } else {
                Notification.error({
                    title: error.response.data.error,
                    message: error.response.data.message,
                })
            }
        }

        return Promise.reject(error)
    }

    service.interceptors.request.use(config => {
        config.url = urls[config.url] || config.url
        const token = store.state.token
        const Language = cookies.get('Language')
        config.headers['Authorization'] = token || ''
        config.headers['Language'] = Language || ''
        return config
    })
    service.interceptors.response.use(response => {
        // console.log(response.config.url, response.headers["refresh_token"]);
        // if (response.headers['refresh_token']) {
        //     if (!ssrContext) {
        //         store.commit('setToken', response.headers['refresh_token'])
        //     }
        // }

        if (response.status == 200) {
            if (response.data.code != 200) {
                if (response.data.code) {
                    Notification.error({
                        title: response.data.message,
                        message: response.data.data,
                    })
                }
            }

            if (response.data.code == 300 && response.data.message == '登录信息已过期') {
                // store.dispatch('loginOut')
                store.dispatch('loginOut', window.location.pathname + window.location.search)
            }
            if (response.data.code == 300 && response.data.message == '请登录') {
                store.dispatch('loginOut', window.location.pathname + window.location.search)
                return Promise.reject(error)
            }
            return response.data || {}
        } else {
            Notification.error({
                title: response.data.message,
                message: response.data.data,
            })
            return response || {}
        }
    }, err)
    const openLoading = () => {
        Loading.hide()
        Loading.show({
            spinner: QSpinnerBall,
            backgroundColor: 'white',
            spinnerColor: 'primary',
            delay: 500, // ms
        })
    }
    const makeUrl = url => {
        if (typeof url == 'string') {
            return urls[url] || url
        } else {
            let ds = url[1]
            url = urls[url[0]] || url
            Object.keys(ds).forEach(k => {
                url = url.replace('{' + k + '}', ds[k])
            })
        }
        return url
    }
    const apiGet = (url, data, loading, isMsg) => {
        if (loading) {
            openLoading()
        }
        return new Promise((resolve, reject) => {
            let params = ''
            if (typeof data == 'object') {
                params = Object.keys(data)
                    .map(function (key) {
                        return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
                    })
                    .join('&')
            } else {
                params = ''
            }
            service
                .get(makeUrl(url) + '?' + params)
                .then(response => {
                    if (loading) {
                        Loading.hide()
                    }
                    resolve(response)
                })
                .catch(() => {
                    reject()
                    Loading.hide()
                })
        })
    }
    const apiPost = (url, data, loading = true) => {
        if (loading) {
            openLoading()
        }
        return new Promise((resolve, reject) => {
            service
                .post(makeUrl(url), data)
                .then(response => {
                    Loading.hide()
                    resolve(response)
                })
                .catch(() => {
                    reject()
                    Loading.hide()
                })
        })
    }
    Vue.mixin({
        methods: {
            apiGet,
            apiPost,
        },
    })
    store.apiGet = apiGet
    store.apiPost = apiPost
    app.axios = service
    Vue.prototype.$axios = service
    store.$axios = service
}
// i18n-ignore>
